import { render, staticRenderFns } from "./importanceSort.vue?vue&type=template&id=36201a57&scoped=true"
import script from "./importanceSort.vue?vue&type=script&lang=js"
export * from "./importanceSort.vue?vue&type=script&lang=js"
import style0 from "./importanceSort.vue?vue&type=style&index=0&id=36201a57&prod&scoped=true&lang=scss"
import style1 from "./importanceSort.vue?vue&type=style&index=1&id=36201a57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36201a57",
  null
  
)

export default component.exports